var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"warp"},[_c('BaseHeader'),_c('main',[_c('PaymentSuccessLeft',{attrs:{"page":"paymentSuccess"}}),_c('div',{attrs:{"id":"payment"}},[_c('a',{staticClass:"btn titillium-sm",staticStyle:{"padding-right":"46px"},on:{"click":_vm.close_window}},[_vm._v(_vm._s(_vm.text.closed)+"  ")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }